<!-- fallow-ignore-file complexity -->
<div
	class="markdown-card-outer-wrapper"
	[class.card--selected]="isSelected()"
	(click)="onCardClick()"
>
	@if (isDebugMode()) {
		<div
			class="debug-info"
			style="
				position: absolute;
				top: 4px;
				left: 4px;
				z-index: 100;
				background: rgba(0, 0, 0, 0.75);
				color: #fff;
				padding: 4px 8px;
				font-size: 10px;
				font-family: 'SF Mono', Monaco, monospace;
				border-radius: 4px;
				backdrop-filter: blur(4px);
				display: flex;
				gap: 8px;
				align-items: center;
			"
		>
			<span style="color: #4fc3f7">{{ cardId() }}</span>
			<span
				style="
					background: #9c27b0;
					padding: 1px 6px;
					border-radius: 3px;
					font-size: 9px;
					text-transform: uppercase;
				"
				>md</span
			>
		</div>
	}

	@if (isLoading()) {
		<div class="markdown-card-loader">
			<jepto-ui-progress-bar-indeterminate />
		</div>
	}

	@if (effectiveTitle() || effectiveSubtitle() || effectiveIcon()) {
		<div class="card-header">
			<div class="card-icon-title-wrapper">
				@if (effectiveIcon()) {
					<mat-icon class="material-symbols-outlined card-icon">{{
						effectiveIcon()
					}}</mat-icon>
				}
				@if (effectiveTitle()) {
					<h2 class="card-title">{{ effectiveTitle() }}</h2>
				}
			</div>
			@if (effectiveSubtitle()) {
				<div class="card-subtitle">{{ effectiveSubtitle() }}</div>
			}
		</div>
	}

	@if (isSelected()) {
		<div class="card-action-buttons">
			<button
				type="button"
				class="card-action-btn"
				aria-label="Edit card"
				(click)="editCard.emit()"
			>
				<span class="icon-edit-2"></span>
			</button>
			<button
				type="button"
				class="card-action-btn"
				aria-label="More options"
				[matMenuTriggerFor]="cardMenu"
				(click)="$event.stopPropagation()"
			>
				<span class="icon-more-vertical"></span>
			</button>
		</div>

		<mat-menu #cardMenu="matMenu" panelClass="card-actions-menu">
			<button mat-menu-item (click)="editCard.emit()">Edit</button>
			<button mat-menu-item (click)="duplicateCard.emit()">
				Duplicate
			</button>
			<button mat-menu-item disabled type="button">Save card</button>
			<button
				mat-menu-item
				class="card-menu-item--danger"
				(click)="deleteCard.emit()"
			>
				Delete
			</button>
		</mat-menu>
	}

	<div class="markdown-card-body">
		<!-- Always mount the preview host so ngAfterViewInit can create TipTap once; content syncs via effect. -->
		<div
			#editorContainer
			class="markdown-card-editor-container"
			[class.markdown-card-editor-container--behind-loader]="isLoading()"
			[class.markdown-card-editor-container--hidden]="
				showCreateTextEmptyState()
			"
		></div>

		@if (showCreateTextEmptyState()) {
			<div class="card-create-empty-state">
				<div class="card-create-empty-state__title">Create Text</div>
				<div class="card-create-empty-state__line">
					Start writing in the Editor to build your card.
				</div>
			</div>
		} @else if (!isLoading() && !effectiveMarkdown()) {
			<div class="empty-state">
				<span>No markdown content available</span>
			</div>
		}
	</div>
</div>
